import { render, staticRenderFns } from "./CardTitle.vue?vue&type=template&id=34fa0670&scoped=true&"
import script from "./CardTitle.vue?vue&type=script&scoped=true&lang=js&"
export * from "./CardTitle.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./CardTitle.vue?vue&type=style&index=0&id=34fa0670&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fa0670",
  null
  
)

export default component.exports